import { render, staticRenderFns } from "./PropertyAssessmentBlock.vue?vue&type=template&id=e5b0aef2&scoped=true&"
import script from "./PropertyAssessmentBlock.vue?vue&type=script&lang=ts&"
export * from "./PropertyAssessmentBlock.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyAssessmentBlock.vue?vue&type=style&index=0&id=e5b0aef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b0aef2",
  null
  
)

export default component.exports